package ui.dialogs

import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import model.NavigationRepository.DialogState
import ui.NavigationViewModel

@Composable
fun HandleDialogs(viewModel: NavigationViewModel) {
    val _dialogState by viewModel.dialogStateStateFlow.collectAsState()
    val dialogState = _dialogState

    when (dialogState) {
        is DialogState.Nothing -> Unit
        is DialogState.LogOutConfirmation -> {
            LogOutDialog(dialogState)
        }
        is DialogState.CancelEnrollment -> {
            CancelEnrollmentDialog(dialogState)
        }
        is DialogState.DeleteCard -> {
            DeleteCardDialog(dialogState)
        }
    }
}